// extracted by mini-css-extract-plugin
module.exports = {"wave2PC":"detail_wave2PC__1_MRb"};